module.exports = __webpack_public_path__ + "img/img-2.f506a9a9.png";